export const getYoutubeVideos = state => state.campaignAnalytics.get('youtubeVideos');
export const getInstagramPosts = state => state.campaignAnalytics.get('instagramPosts');
export const getFacebookPosts = state => state.campaignAnalytics.get('facebookPosts');
export const getTwitterPosts = state => state.campaignAnalytics.get('twitterPosts');
export const isLoading = state => state.campaignAnalytics.get('loading');



/** WEBPACK FOOTER **
 ** ./src/selectors/campaign-analytics-selectors.js
 **/